import { render, staticRenderFns } from "./TeacherPicture.vue?vue&type=template&id=0f889382&scoped=true&"
import script from "./TeacherPicture.vue?vue&type=script&lang=js&"
export * from "./TeacherPicture.vue?vue&type=script&lang=js&"
import style0 from "./TeacherPicture.vue?vue&type=style&index=0&id=0f889382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f889382",
  null
  
)

export default component.exports